import type { IconData } from '@stacksjs/iconify-core'

export const lightbulb: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M13.516 33.383C9.55 30.271 7 25.433 7 20c0-9.389 7.611-17 17-17s17 7.611 17 17c0 5.433-2.549 10.271-6.516 13.383a67 67 0 0 1-.972 3.48c-.306.998-1.135 1.723-2.174 1.832C29.945 38.84 27.596 39 24 39s-5.945-.16-7.338-.305c-1.039-.109-1.868-.834-2.174-1.833c-.287-.933-.65-2.18-.972-3.479\"/><path d=\"M16.488 38.67c.203 1.31.414 2.502.59 3.444c.25 1.325 1.192 2.389 2.525 2.59c1.046.159 2.499.296 4.397.296c1.805 0 3.288-.124 4.417-.272c1.584-.208 2.694-1.526 2.866-3.115l.321-2.96M34 19c0-5.523-4.477-10-10-10\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default lightbulb
